import {
  Button,
  Captcha,
  GenericLoader,
  If,
  Otp,
  useI18n,
  widgets,
} from '@nosinovacao/nosid-mfe-common';
import { defaultCodeInputTranslations, type CodeInputProps } from './props';

export function CodeInputWoo({
  translations: translationOverrides,
  codeValue,
  codeId,
  codeErrors,
  isValidating,
  isSending,
  captchaChallenge,
  onCaptchaChange,
  onCodeChange,
  onResend,
  onSubmit,
}: Readonly<CodeInputProps>) {
  const { t } = useI18n();
  const translations = { ...defaultCodeInputTranslations, ...translationOverrides };

  return (
    <form
      data-tid="form-code-input"
      className="flex size-full flex-col items-center gap-12 overflow-y-auto pt-8"
      onSubmit={onSubmit}
    >
      <Otp
        data-tid="otp-code"
        skin="woo"
        id={codeId}
        value={codeValue}
        onChange={onCodeChange}
        length={widgets.ValidationCodeLength}
        errors={codeErrors}
        disabled={isValidating}
        autoFocus
      />

      <Button
        data-tid="button-resend-code"
        skin="woo"
        variant="tertiary"
        type="button"
        onClick={onResend}
        disabled={isSending || isValidating}
      >
        <If condition={isSending} otherwise={t(translations.resendCode)}>
          <GenericLoader className="size-6 animate-spin border-woo-green-100" />
        </If>
      </Button>

      <If condition={captchaChallenge}>
        <Captcha onChange={onCaptchaChange} />
      </If>

      <div className="mt-auto w-full pb-8">
        <Button
          data-tid="button-confirm"
          skin="woo"
          className="max-tablet:w-full"
          disabled={codeValue.length < widgets.ValidationCodeLength || isValidating || isSending}
          type="submit"
        >
          <If condition={isValidating} otherwise={t(translations.confirm)}>
            <GenericLoader className="size-6 animate-spin border-woo-green-100" />
          </If>
        </Button>
      </div>
    </form>
  );
}
